module.exports = __webpack_public_path__ + "static/f4de461faec9a9620e74ab11334b37f89b5bbc17cf7f86f928d730d2813bd1ff-bb7201243d2b4a3c0e0e422363d3fe4f.png";